import React from 'react'

import { ProgressDescriptionProps, SectionProps } from './type'

const Panel = () => {
  const childPanels = Array.from({ length: 3 }, (_, index) => (
    <div className="indicator" key={index}></div>
  ))
  return <div className="panel-container">{childPanels}</div>
}

const Section = ({ className, name, value, hasPanel }: SectionProps) => (
  <div className={className}>
    <div className="section-name">{name}</div>
    {value && <div className="section-value">{value}</div>}
    {hasPanel && <Panel />}
  </div>
)

export const ProgressDescription = ({ progressDescriptionBlock }: ProgressDescriptionProps) => {
  const { beforeSections, afterSections } = progressDescriptionBlock

  return (
    <>
      <div className="block-before">
        {beforeSections.map((section, index) => (
          <Section
            key={index}
            className={`section ${index}`}
            name={section.name}
            value={section.value}
            hasPanel={section.hasPanel}
          />
        ))}
      </div>
      <div className="line-vertical"></div>
      <div className="block-after">
        {afterSections.map((section, index) => (
          <Section
            key={index}
            className={`section ${index}`}
            name={section.name}
            value={section.value}
            hasPanel={section.hasPanel}
          />
        ))}
      </div>
    </>
  )
}
